<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'DialogId4',
  components: { ModuleTitle },
  props: {
    currentModule: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      pageData: [],
      src: 'https://jdydt.ccdi.gov.cn/#/',
      src2: 'https://www.dandelioncloud.cn/article/details/1515142599911460866',
      src3: 'http://baihutanpad.cdjsc.com.cn/#'
    }
  },
  computed: {
    ...mapGetters({
      currentModalNameGetter: 'config/getCurrentModalName'
    }),
    currentModalName() {
      return this.currentModalNameGetter
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<template>
  <div class="dialog-id-14">
    <div class="title-container">
      <module-title :title="currentModule.title" :margi-bottom="40" />
      <!-- <p class="label label2">小微权力“监督一点通”</p> -->
    </div>
    <div v-if="currentModalName === '洪韵雅廉'" class="dialog-container">
      <el-image class="line" :src="require('imgs/modules/dialog-modules/id-4-line.png')" alt="line" />
      <div class="main-box">
        <p class="label">洪韵雅廉</p>
        <el-image class="qrcode" :src="require('imgs/modules/id-32-qrcode.png')" alt="qrcode" />
        <p class="qr-title">—— 微信扫一扫关注公众号 ——</p>
        <p class="account-title">公众号简介</p>
        <p class="account-intro">传播党风廉政建设权威声音，培育廉洁土壤，弘扬廉洁文化，传递廉洁能量，接受社会监督。</p>
      </div>
    </div>
    <div v-else-if="currentModalName === '小微权力“监督一点通”'" class="dialog-container">
      <p class="label">小微权力“监督一点通”</p>
      <el-image class="qrcode" :src="require('imgs/modules/id-32-qrcode2.png')" alt="qrcode" />
      <p class="qr-title">—— 扫一扫进入平台 ——</p>
      <!-- <div class="iframe-box">
        <iframe
          class="iframe"
          :src="src3"
        />
      </div> -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
// 1330
.dialog-id-14 {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title-container {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
  .dialog-container {
    width: 957px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
    .line {
      width: 957px;
      height: 25px;
    }
  }
}
.main-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 913px;
  background-color: #fafafa;
  padding: 14px 22px 30px;
  box-sizing: border-box;
}

.label {
  min-width: 130px;
  height: 40px;
  background: linear-gradient(95deg, #50B7B5, #58C2F6);
  border: 2px solid #EBF7FF;
  box-shadow: 3px 7px 0 0 rgba(0, 0, 0, 0.26);
  border-radius: 10px;
  text-align: center;
  line-height: 30px;
  padding: 2px 10px 0;
  box-sizing: border-box;
  margin-top: 20px;

  font-size: 19px;
  font-family: siyuansong;
  font-weight: 800;
  color: #fff;
}
.label2 {
  margin: 10px 0 0 20px;
}
.qrcode {
  width: 193px;
  height: 193px;
  margin-top: 46px;
}
.qr-title {
  font-size: 15px;
  font-weight: bold;
  color: #000;
  background: linear-gradient(95deg, #50B7B5 0%, #58C2F6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-top: 30px;
}
.account-title {
  font-size: 17px;
  font-weight: bold;
  color: #000;
  margin-top: 46px;
}
.account-intro {
  width: 419px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
  line-height: 29px;
  margin-top: 22px;
  text-align: center;
}

.iframe-box {
  width: 1330px;
  height: 635px;
  .iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
